<template>
  <div class="container-fluid">
    <h2>CMS Mail Manager</h2>
    <hr/>
    <div class="row">
      <div class="col" style="max-width:300px;">
        <h4>Verzeichnisse</h4>
        <CTreeView @selectnode="updateList" treeid="jsonmailtemplate"/>
      </div>
      <div class="col-9">
        <div role="toolbar" class="btn-toolbar justify-content-between">
          <div class="btn-group">
            <button @click="prevPage" class="btn btn-secondary" id="prev"><font-awesome-icon icon="chevron-left"/></button>
            <button @click="nextPage" class="btn btn-secondary" id="next"><font-awesome-icon icon="chevron-right"/></button>
          </div>
            <button class="btn btn-primary" @click="addCMSDocument()">Neue Vorlage</button>
        </div>
        <b-table class="mt-3" id="docTable" :fields="fields" :items="rows">
          <template v-slot:cell(action)="data">
            <div class="btn-group">
              <button @click="openDocument(data.item)" class="btn btn-primary"><font-awesome-icon icon="edit"/></button>
              <button @click="deleteDocument(data.item)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import cmsdocs from '@/modules/cmsdocs.js'
import CTreeView from '@/components/tree/CTreeView.vue'

export default {
  name: 'UIManager',
  components: {
    CTreeView,
  },
  data() {
    return {
      rows: [],
      start: 0,
      count: 20,
      catID: 0,
      fields: [
        { "key": "id", "label": "ID" },
        { "key": "title", "label":"Titel" },
        { "key": "label", "label":"Beschreibung" },
        { "key": "action", "label":"Aktion"}

      ]
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      var data = await cmsdocs.list(this.catID,"jsonmail",this.start,this.count);
      console.log('cms list',data,this);
      this.rows = data;
    },
    updateList(node) {
      console.log('node select',node);
      if (node) {
        this.catID = node.id;
        this.fetchData();
      }
    },

    addCMSDocument() {
      router.push({ name: 'CMSMailEditor', params: { catid: this.catID, docid: 0}})
    },

    addCMSReport() {

    },
    addCMSFormular() {

    },
    deleteDocument(doc) {
      if (doc.docType == 0) {
        console.log('delete cms document',doc.id);
        if (!confirm('Möchten Sie das Dokument "' + doc.label + '" wirklich löschen?')) {
          return;
        }
        cmsdocs.deleteDocument(doc.id);
        this.fetchData();
      } else {
        console.error('Delete not implemented for type',doc.docType);
      }
    },

    prevPage() {
      if (this.start > 0) {
        this.start = Math.max(0,this.start - this.count);
        //this.fetchData();
      }
    },
    nextPage() {
      this.start += this.count;
      //this.fetchData();
    },

    openDocument(item) {
      console.log('open doc',item);
      router.push({ name: 'CMSMailEditor', params: { catid: item.catID, docid: item.id}})
    },

  }
}
</script>
